<ng-container *ngIf="showInstallModal$ | async">
    <ng-container *transloco="let t; read:'installModal'">
        <modal #installModal [cancelLabel]="t('no')" [okLabel]="t('yes')" [autoOpen]="true" (cancel)="cancel()" (ok)="ok()">
            <div [innerHTML]="t('text')"></div>
        </modal>
    </ng-container>
</ng-container>
